import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { MinkaLoginService } from './minka-login.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './environment';
import { locale as english } from './i18n/en';
import { locale as espanol } from './i18n/es';
import { FuseTranslationLoaderService  } from './translation-loader.service';
import { fuseAnimations } from './animations';
import { FuseConfigService } from './services/config.service';

const API_URL = environment.API_URL;
const ACCESS_TOKEN_KEY = environment.ACCESS_TOKEN_KEY;
const USER_SESSION_KEY = environment.USER_SESSION_KEY;

@Component({
  selector: 'minkalib-minka-lib',
  templateUrl  : './minka-login.component.html',
  styleUrls    : ['./minka-login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
    
})

export class MinkaLoginComponent implements OnInit {
    idioma;
    languages: any =[];
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    loginForm: FormGroup;
 
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _minkaService: MinkaLoginService,
    private _translateService: TranslateService,
    private _router: Router,
    private _matSnackBar: MatSnackBar,
    public _translate : TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
    
  ) {

    this._fuseConfigService.config = {
        layout: {
            navbar   : {
                hidden: true
            },
            toolbar  : {
                hidden: true
            },
            footer   : {
                hidden: true
            },
            sidepanel: {
                hidden: true
            }
        }
    };

    this.languages = [
        {
            id   : 'en',
            title: 'English',
            flag : 'us'
        },
        {
            id   : 'es',
            title: 'español',
            flag : 'tr'
        }
    ];

    this._translate.addLangs(['en','es']);
    
    if(localStorage.getItem("idioma")){
        this.idioma=localStorage.getItem("idioma");
        this._translate.setDefaultLang(localStorage.getItem("idioma"));
        this._translate.use(localStorage.getItem("idioma"));
    }else{
        this._translate.setDefaultLang('es');
        this._translate.use('es');
    }
    
    this._fuseTranslationLoaderService.loadTranslations(english, espanol);
   }

    ngOnInit(): void{
      this.loginForm = this._formBuilder.group({
          email   : ['', [Validators.required, Validators.email]],
          password: ['', Validators.required]
      });
       this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
    }

    nofityLoginError(): void{
    
          this._matSnackBar.open(
              'Usuario o contraseña no coinciden.', 
              'Aceptar', 
              {   
                  duration: 3500, 
                  horizontalPosition:'right', 
                  verticalPosition:'bottom'
              }
          );
    }
    
    onSubmit(){
          // Declaración de variables        
          let token: string;
    
          let params = {
              'client_id' 	: 2,
              'client_secret' : 'DDcSWbNIYvSJxTB2aVXQ4ekp1dN11BCL8oRLLfQR',
              'grant_type' 	: 'password',
              'username'		: this.loginForm.value.email,
              'password'		: this.loginForm.value.password
          };
    
          this._minkaService.httpPost('oauth/token', params)
          .subscribe(
              (response: any) => {        
                  
                  token = response.access_token;
                  this._minkaService.setAccessToken(token);
                  localStorage.setItem(ACCESS_TOKEN_KEY, token);
                  let app_id = environment.APP_ID;
                  this._minkaService.httpPost('api/login/usuarioweb', {app_id})
                  .subscribe(
                      (responseLogin: any) => {
    
                          if(responseLogin.Code == "M1"){
                              let usuario = responseLogin.Data.usuario;
                              this._minkaService.setUserSession(usuario);
                              localStorage.setItem(USER_SESSION_KEY, JSON.stringify(usuario));
                              this._router.navigate(['proyecto']);
                          } else {
                              this.nofityLoginError();
                          }
                      },
                      errorLogin => {
                          this.nofityLoginError();
                      }
                  );
              },
              error => {
                  this.nofityLoginError();
              }
          );
    }

    setLanguage(lang): void{        
        this._translate.use(lang);

        localStorage.setItem("idioma", lang);
    }

    openFormRecoveryPassword(){
        this._router.navigate(['forgot-password']);
    }

}
